var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWatchMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00010847 12.88V1.71004C-0.00104663 1.51141 0.0569754 1.31695 0.166777 1.15143C0.276578 0.985906 0.433183 0.856835 0.616628 0.780669C0.800072 0.704502 1.00204 0.68469 1.19679 0.72376C1.39154 0.76283 1.57024 0.85901 1.71011 1.00004L7.29012 6.59004C7.47638 6.7774 7.58092 7.03085 7.58092 7.29504C7.58092 7.55923 7.47638 7.81268 7.29012 8.00004L1.71011 13.59C1.57024 13.7311 1.39154 13.8272 1.19679 13.8663C1.00204 13.9054 0.800072 13.8856 0.616628 13.8094C0.433183 13.7332 0.276578 13.6042 0.166777 13.4387C0.0569754 13.2731 -0.00104663 13.0787 0.00010847 12.88Z",
    fill: "#374957"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchMore);
export default __webpack_public_path__ + "static/media/watch_more.3137f47be285bdd135f1c535fc9cb3a6.svg";
export { ForwardRef as ReactComponent };